import { useEffect, useState } from "react";
import { ArrayTotalizarByProp } from "./TotalizarProps";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const GastosConsolidados = ({ state }) => {
    const [totalesV, setTotalesV] = useState({
        real: 0,
        proyeccion: 0,
        porc: 0,
        diferencia: 0,
        realant: 0,
        porcant: 0,
        diferenciaant: 0
    });
    const [totalesF, setTotalesF] = useState({
        real: 0,
        proyeccion: 0,
        porc: 0,
        diferencia: 0,
        realant: 0,
        porcant: 0,
        diferenciaant: 0
    });

    console.log(state)

    useEffect(() => {
        const real = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "total");
        const proyeccion = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "proyeccion");
        const diferencia = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "dif");
        const porc = proyeccion === 0 || diferencia === 0 ? 0 : diferencia / proyeccion * 100;
        const realant = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "oldtotal");
        const diferenciaant = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "olddif");
        const porcant = diferenciaant === 0 || realant === 0 ? 0 : diferenciaant / realant * 100;

        setTotalesV({
            real: FormatMoney(real),
            proyeccion: FormatMoney(proyeccion),
            porc: FormatMoney(porc),
            diferencia: FormatMoney(diferencia),
            realant: FormatMoney(realant),
            porcant: FormatMoney(porcant),
            diferenciaant: FormatMoney(diferenciaant)
        })
    }, [state]);

    useEffect(() => {
        const real = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "total");
        const proyeccion = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "proyeccion");
        const diferencia = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "dif");
        const porc = proyeccion === 0 || diferencia === 0 ? 0 : diferencia / proyeccion * 100;
        const realant = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "oldtotal");
        const diferenciaant = ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "olddif");
        const porcant = diferenciaant === 0 || realant === 0 ? 0 : diferenciaant / realant * 100;
        setTotalesF({
            real: FormatMoney(real),
            proyeccion: FormatMoney(proyeccion),
            porc: FormatMoney(porc),
            diferencia: FormatMoney(diferencia),
            realant: FormatMoney(realant),
            porcant: FormatMoney(porcant),
            diferenciaant: FormatMoney(diferenciaant)
        })
    }, [state]);

    const getIndicadorClass = (indicador) => {
        switch (indicador) {
            case "V":
                return "indicador-verde";
            case "A":
                return "indicador-amarillo";
            case "R":
                return "indicador-rojo";
            default:
                return "";
        }
    };

    const limpiarNumero = (valor) => {
        if (typeof valor === "string") {
            return Number(valor.replace(/[^0-9.-]+/g, ""));
        }
        return Number(valor);
    };

    const getIndicador = (importe, proyectado) => {
        // if (!proyectado || proyectado === 0) return "";

        // console.log(importe, proyectado)

        const diferencia = (1 + (limpiarNumero(importe) - limpiarNumero(proyectado)) / Math.abs(limpiarNumero(proyectado))) * 100;

        console.log(diferencia)
        if (diferencia < 95) {
            return "V";
        } else if (diferencia <= 105) {
            return "A";
        } else {
            return "R";
        }
    };

    return (
        <>
            <tr style={{
                fontWeight: 'bold',
                fontSize: 14,
                letterSpacing: 1,
                textAlign: 'center'
            }}>
                <td className='bl br' colSpan={10}>Gastos Variables</td>
            </tr>
            {
                state.data.filter(x => x.tipo === 'V').map((item) => (
                    <tr>
                        <td className="bl">{item.cuenta}</td>
                        <td>{item.concepto}</td>
                        <td className="ta-right bl">{FormatMoney(item.total)}</td>
                        <td className="ta-center" style={{ width: "20px" }}>
                            <span className={`indicador ${getIndicadorClass(item.indicador)}`}></span>
                        </td>
                        <td className="ta-right">{FormatMoney(item.proyeccion)}</td>
                        <td className="ta-right ">{FormatMoney(item.porc)}</td>
                        <td className="ta-right">{FormatMoney(item.dif)}</td>
                        <td className="ta-right bl">{FormatMoney(item.oldtotal)}</td>
                        {/* <td className="ta-right">
                        {FormatMoney(item.oldproyeccion)}
                      </td> */}
                        <td className="ta-right ">{FormatMoney(item.oldporc)}</td>
                        <td style={{ paddingRight: 10 }} className="ta-right br">
                            {FormatMoney(item.olddif)}
                        </td>
                    </tr>
                ))
            }
            <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                <td
                    colSpan={2}
                    style={{
                        fontWeight: "bold",
                        textAlign: "right",
                        paddingRight: 10,
                    }}
                    className="bl"
                >
                    Total Gastos Variables
                </td>
                <td className="ta-right">
                    {totalesV.real}
                    {/* {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "total"))} */}
                </td>
                <td className="ta-center">
                    <span className={`indicador ${getIndicadorClass(getIndicador(totalesV.real, totalesV.proyeccion))}`}></span>
                </td>
                <td className="ta-right">
                    {totalesV.proyeccion}
                    {/* {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "proyeccion"))} */}
                </td>
                <td className="ta-right">
                    {totalesV.porc}
                </td>
                <td className="ta-right">
                    {totalesV.diferencia}
                    {/* {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "dif"))} */}
                </td>
                <td className="ta-right">
                    {totalesV.realant}
                    {/* {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "oldtotal"))} */}
                </td>
                {/* <td className="ta-right">
                  {FormatMoney(
                    ArrayTotalizarByProp(state.data, "oldproyeccion")
                  )}
                </td> */}
                <td className="ta-right">
                    {totalesV.porcant}
                </td>
                <td className="ta-right br">
                    {totalesV.diferenciaant}
                    {/* {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'V'), "olddif"))} */}
                </td>
            </tr>
            <tr>
                <td colSpan={10}></td>
            </tr>
            <tr style={{
                fontWeight: 'bold',
                fontSize: 14,
                letterSpacing: 1,
                textAlign: 'center'
            }}>
                <td className='bl br' colSpan={10}>Gastos Fijos</td>
            </tr>
            {
                state.data.filter(x => x.tipo === 'F').map((item) => (
                    <tr>
                        <td className="bl">{item.cuenta}</td>
                        <td>{item.concepto}</td>
                        <td className="ta-right bl">{FormatMoney(item.total)}</td>
                        <td className="ta-center">
                            <span className={`indicador ${getIndicadorClass(item.indicador)}`}></span>
                        </td>
                        <td className="ta-right">{FormatMoney(item.proyeccion)}</td>
                        <td className="ta-right ">{FormatMoney(item.porc)}</td>
                        <td className="ta-right">{FormatMoney(item.dif)}</td>
                        <td className="ta-right bl">{FormatMoney(item.oldtotal)}</td>
                        {/* <td className="ta-right">
                        {FormatMoney(item.oldproyeccion)}
                      </td> */}
                        <td className="ta-right ">{FormatMoney(item.oldporc)}</td>
                        <td style={{ paddingRight: 10 }} className="ta-right br">
                            {FormatMoney(item.olddif)}
                        </td>
                    </tr>
                ))
            }
            <tr style={{ fontWeight: "bold", fontSize: 12 }}>
                <td
                    colSpan={2}
                    style={{
                        fontWeight: "bold",
                        textAlign: "right",
                        paddingRight: 10,
                    }}
                    className="bl"
                >
                    Total Gastos Fijos
                </td>
                <td className="ta-right">
                    {/* {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "total"))} */}
                    {totalesF.real}
                </td>
                <td className="ta-center">
                    <span className={`indicador ${getIndicadorClass(getIndicador(totalesF.real, totalesF.proyeccion))}`}></span>
                </td>
                <td className="ta-right">
                    {/* {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "proyeccion"))} */}
                    {totalesF.proyeccion}
                </td>
                <td className="ta-right">
                    {totalesF.porc} %
                </td>
                <td className="ta-right">
                    {totalesF.diferencia}
                    {/* {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "dif"))} */}
                </td>
                <td className="ta-right">
                    {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "oldtotal"))}
                </td>
                {/* <td className="ta-right">
                  {FormatMoney(
                    ArrayTotalizarByProp(state.data, "oldproyeccion")
                  )}
                </td> */}
                <td className="ta-right">
                    {totalesF.porcant} %
                </td>
                <td className="ta-right br">
                    {totalesF.diferenciaant}
                    {/* {FormatMoney(ArrayTotalizarByProp(state.data.filter(x => x.tipo === 'F'), "olddif"))} */}
                </td>
            </tr>
            <tr>
                <td colSpan={10}></td>
            </tr>
        </>
    )
}
